import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { GatePass } from 'src/app/_models/gate_pass';
import { Guardian } from 'src/app/_models/guardian';
import { User } from 'src/app/_models/user';
import { AuthService } from 'src/app/_services/auth.service';
import { GuardianService } from 'src/app/_services/guardian.service';
import { UserService } from 'src/app/_services/user.service';

@Component({
  selector: 'app-user-edit-general',
  templateUrl: './user-edit-general.component.html',
  styleUrls: ['./user-edit-general.component.css']
})
export class UserEditGeneralComponent implements OnInit {

  user = undefined
  userEditForm :FormGroup
  guardian= new Guardian()
  update_success=false
  gatePass:GatePass=new GatePass()
  constructor(
    private route:ActivatedRoute,
    private userService:UserService,
    public authService:AuthService,
    private guardianService:GuardianService
  ) { }
  get f(){
    return this.userEditForm.controls
  }
  ngOnInit(): void {
    this.route.params.subscribe(
      x=>{
        this.userService.getById(x['server_user_id']).subscribe({
      next: (x2)=>{
            this.user=x2.rs.data
            this.initForm(this.user)
          }
        }


        )
      }
    )
    this.guardianService.guardianSubject.subscribe(
      x=>{
        this.guardian=x
      }
    )
    this.authService.gatePass.subscribe(
      gatePass=>{
        this.gatePass=gatePass
      }
    )
  }

  initForm(myUser:User){
    this.userEditForm = new FormGroup({
      'firstName': new FormControl(myUser.firstname, [Validators.required]),
      'lastName': new FormControl(myUser.lastname, [Validators.required]),
      'username': new FormControl({value:myUser.username,disabled:true}, [Validators.required]),
      'officeNumber': new FormControl(myUser.officeNumber, [Validators.required]),
      'mobileNumber': new FormControl(myUser.mobileNumber, [Validators.required])
    });

  }
  on_submit(){
    this.update_success= false

    let user2 = new User()
    user2.firstname=this.userEditForm.value.firstName
    user2.lastname=this.userEditForm.value.lastName

    user2.officeNumber=this.userEditForm.value.officeNumber
    user2.mobileNumber=this.userEditForm.value.mobileNumber
    user2.password=this.userEditForm.value.password
    user2.enabled=this.userEditForm.value.enabled
    user2.accountLocked=this.userEditForm.value.accountLocked
    user2.forcePasswordChange=this.userEditForm.value.forcePasswordChange
    user2.id=+this.user.id
    this.userService.update(user2).subscribe(
      x=>{
        this.user=x
        this.update_success=true
      }
    )

  }


}
